/*
data.js - holds frequently used data structures for lists, selects, etc.
ॐ नमो नारायणाय - Om Namo Narayanaya
------------------------------------------------------------------------------- */
/* Constant Values
------------------------------------------------------------------------------- */
export const APP_NAME = 'Xolas TMS'

export const VERSION = require('../../package.json').version

export const COOKIE = 'xolas-user'
export const CONFIG = 'xolas-config'

export const IS_DEV = (process.env.NODE_ENV === 'development')
export const IS_MAINT = false
export const IS_UNPAID = false

export const HTTP_PROTOCOL = 'https://'

export const MAP_SEARCH_EVENT = 'map-geo-search'
export const MAP_RESET_EVENT = 'map-reset'
export const SITETABLE_VIEW_EVENT = 'site-table-view'

export const DISABLE_SAVE_EVENT = 'disable-save-modal'
export const ENABLE_SAVE_EVENT = 'enable-save-modal'

export const DATE_SQL_FORMAT = 'YYYY-MM-DD'
export const DATETIME_SQL_FORMAT = 'YYYY-MM-DD HH:mm:ss'

export const NEW_SITE = 'New'
export const ACTIVE_SITE = 'Active'
export const EXCLUSIVE_SITE = 'Exclusive'
export const LAND_ONLY_SITE = 'Land-Only'
export const CANDIDATE_SITE = 'Candidate'
export const DISMANTLED_SITE = 'Dismantled'
export const SOLD_SITE = 'Sold'
export const TEMP_SITE = 'Temporary'

export const GOOGLE_API_KEY = 'AIzaSyBKr4u-Jc62XttAAZT-wewCltAtPtEB3jA'

export const RECAPTCHA_KEY = '6Lcd37QgAAAAAHDfErx9Jr9B9GiWQyAk5XyHePkV'
export const SECRET_RECAPTCHA_KEY = '6Lcd37QgAAAAAPBY0AFbSDrFhAECM8frM0L6FpX3'

export const MAP_PINS = ['static/map/marker.png', 'static/map/road-map.png', 'static/map/power-map.png', 'static/map/building-map.png',
  'static/map/yellow-map.png', 'static/map/green-map.png', 'static/map/red-map.png', 'static/map/blue-map.png', 'static/map/grey-map.png', 'static/map/black-map.png', 'static/map/google-map.png',
  'static/map/yellow-road-map.png', 'static/map/green-road-map.png', 'static/map/red-road-map.png', 'static/map/blue-road-map.png', 'static/map/grey-road-map.png', 'static/map/black-road-map.png'
]

import {getSettings, getRegions, getSubset} from '@/components/config/'

/*
Data structures
------------------------------------------------------------------------------- */

export const settings = getSettings()

export const localityData = getRegions()

export const assetCategoryData = require('@/components/config/assets-categories.json')

export const structureTypeData = getSubset(assetCategoryData, 'Structure')

export const backhaulTypeData = getSubset(assetCategoryData, 'Transmission', 'Backhaul')

export const chartColors = ['#F99B19', '#F6F05D', '#B0D235', '#8A5980', '#32234A', '#FEF8AB', '#7C9E5D', '#A43B5D', '#1C4157', '#6A3150', '#2A3647', '#736CC1', '#B0B15B', '#C4A344', '#984029', '#1C4157', '#459BBF', '#B7CFDC', '#AE7B43', '#615242', '#C27B63', '#FDF696', '#91D9BC', '#7E4777', '#343E5D', '#34A8DF', '#7EC8C9', '#C5EBD1', '#A59A7F', '#50383A', '#19406A', '#325B94', '#7190A5', '#C4A552', '#615618', '#4D3817', '#824F1E', '#A8B282', '#5B5E83', '#4B4F74', '#5A5F67', '#A4AA68', '#98745D',
  '#2F5B54', '#81BBBA', '#EFEEDF', '#949639', '#92522E', '#30352B', '#6B9AA7', '#96AD93', '#DCC6AD', '#918863', '#1E2733', '#2E456B', '#5DA0CE', '#9ABED7', '#CDD1D5', '#F4AB17', '#823D1B', '#541C1F', '#777A72', '#CE92BC', '#EA5936', '#F46845', '#CEC62A', '#A9D89E', '#26D197', '#A36E62', '#7F574A', '#BCAA9B', '#D6CE9F', '#978450', '#5B3C19', '#5A3F28', '#6E775C', '#A39669', '#9B9B48', '#1A4577', '#264D7F', '#93CEE6', '#8EACCE', '#B8ACB1', '#0E1C21', '#348BAE', '#5FB2E8', '#F0AB29', '#8B602F']
